import React from 'react'
import classNames from 'classnames'
import styles from './index.module.less'

export default ({ label, value, mb12 = true, style = null, styleValue = null, onClickValue = null }) => {
  return <div className={classNames(styles['mn-style-item'], { mb12 })} style={style}>
    <div className="label">{label}</div>
    <div
      style={styleValue}
      onClick={() => {
        onClickValue && onClickValue(value)
      }}
      className={classNames('value', 'text-overflow', { empty: !value })}
    >{value || '未填写'}</div>
  </div>
}
